'use client';

import { useEffect, useState } from "react";
import style from "./styleSelector.module.scss";
import { useTekstClient } from "../../../hooks/useTekstClient";
import { useDropdown } from './useDropdown';
import { useAxios } from "../../../hooks/useAxios";
import { IoMdArrowDropdown } from "@react-icons/all-files/io/IoMdArrowDropdown";
import { IoMdArrowDropup } from "@react-icons/all-files/io/IoMdArrowDropup";
import {reverseTranslateSegments, translateSegments} from "../../../lib/pathTranslation";
import { useSWRConfig} from "swr"
const LanguageDropdown = () => {
    const { isOpen, toggleDropdown, closeDropdown, dropdownRef } = useDropdown();
    const { tekst } = useTekstClient();
    const { get } = useAxios();
    const {mutate} = useSWRConfig()

    const [languages, setLanguages] = useState([]);

    const [langCookie, setLangCookie] = useState();
    const [countryCookie, setCountryCookie] = useState();

    useEffect(() => {
        if (typeof document === "undefined") return;

        const cookie = document.cookie
            .split('; ')
            .find((row) => row.startsWith(`NEXT_LOCALE=`))
            ?.split('=')[1];

        const splittedCookie = cookie.split('-')
        setLangCookie(splittedCookie[0]);
        setCountryCookie(splittedCookie[1]);
    }, []);

    // Fetch languages from API
    useEffect(() => {
        get("/released/languages").then((res) => {
            const dataLang = []

            res.data.forEach((d) => {
                const obj = {
                    id: d.id,
                    name: d.naam,
                }

                dataLang.push(obj)
            })

            setLanguages(dataLang)
        });
    }, []);

    const setTaal = (taal, newLocale) =>{
        // this is so the language settings stay in sync with the user account settings (important for mail)
        get( `/locale/${taal}`).then(response =>{
            if(response.status === 200) {
                mutate(key => true)

                // Get current path and translate segments
                const currentPath = window.location.pathname;
                const currentLocaleMatch = currentPath.match(/^\/([a-z]{2}-[a-z]{2})(\/.*)?$/i);

                if (currentLocaleMatch) {
                    const currentLocaleFull = currentLocaleMatch[1];
                    const currentLang = currentLocaleFull.split('-')[0];
                    const newLang = newLocale.split('-')[0];
                    const restOfPath = currentLocaleMatch[2] || '';

                    // Remove locale slug from path
                    const cleanedPath = restOfPath;

                    // Reverse translate from current language to canonical form
                    const canonicalPath = reverseTranslateSegments(cleanedPath, currentLang);

                    // Translate to new language
                    const translatedPath = translateSegments(canonicalPath, newLang);

                    // Build new URL with translated path
                    window.location.href = `/${newLocale}${translatedPath}`;
                } else {
                    // No locale in URL, just reload
                    window.location.reload();
                }
            }
        })


    }

    return (
        <div className={style.selectorContainer} ref={dropdownRef}>
            <button className={style.triggerButton} onClick={toggleDropdown} aria-expanded={isOpen} aria-haspopup="true">
                <span className={style.currentSelection} suppressHydrationWarning>
                    {tekst('website:menu:language')} - {langCookie?.toUpperCase()}
                    <span className={style.dropdownArrow}>
                        {isOpen ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
                    </span>
                </span>
            </button>

            {isOpen && (
                <div className={style.selectorWrapper}>
                    <span className={style.trianglePointer}></span>
                    <div className={style.dropdownMenu}>
                        <div className={style.menuContent}>
                            {languages.map((language) => (
                                <button key={language?.id}
                                        className={`${style.menuItem} ${
                                            langCookie?.toUpperCase() === language?.name ? style.selectedItem : ''
                                        }`}
                                        onClick={() => {
                                            const localeFull = `${language.name.toLowerCase()}-${countryCookie}`;
                                            document.cookie = `NEXT_LOCALE=${encodeURIComponent(localeFull)}; Path=/; Max-Age=31536000; SameSite=Lax`;

                                            setTaal(language.name.toLowerCase(), localeFull)
                                        }

                                }
                                >
                                    <span className={style.itemLabel}>{language?.name.toUpperCase()}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LanguageDropdown;